import { useEffect } from "react";
import { wireSyncAnalytics } from "../integrations/syncIntegration";
import { wirePwaAnalytics } from "../integrations/pwaIntegration";
import { ensureAnalyticsInitialized } from "../service/analyticsService";

/**
 * Mount once at app root — registers passive integrations (sync, app_open).
 */
export function useAnalyticsBootstrap() {
  useEffect(() => {
    void ensureAnalyticsInitialized();
    const unwireSync = wireSyncAnalytics();
    const unwirePwa = wirePwaAnalytics();
    return () => {
      unwireSync();
      unwirePwa();
    };
  }, []);
}
